import { render, staticRenderFns } from "./ReceiptSettingLogoPicker.vue?vue&type=template&id=cda54864&"
import script from "./ReceiptSettingLogoPicker.vue?vue&type=script&lang=js&"
export * from "./ReceiptSettingLogoPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports